import(/* webpackMode: "eager" */ "/vercel/path0/app/solutions/marketplace/page.tsx");
